import { handleVideos, selectCurrentLightbox, selectCurrentVideoGallery } from "./VideoGallery";

const hasLightbox = document.querySelectorAll('.video-lightbox').length > 0;
const isMobile = window.matchMedia('(max-width: 768px)').matches;
const lightboxCloseBtn = document.querySelector('.video-lightbox__close');

let lightbox;
let videoGallery;
let currentVideo = 0;
let videoCount = 0;

let touchstartY = 0;
let touchendY = 0;

if (hasLightbox && isMobile) {
    document.addEventListener('click', (e) => {
        lightbox = selectCurrentLightbox(e);
        videoGallery = selectCurrentVideoGallery(e);
        if (!lightbox) {
            return;
        }

        if ((e.target.classList.contains('video') || e.target.closest('.video'))) {
            handleVideos(e);
            openLightbox(lightbox);
        }

        if (e.target.classList.contains('video-list__title')) {
            const title = e.target;
            const titleCount = title.getAttribute('data-count');
            currentVideo = parseInt(titleCount);

            openLightbox(lightbox);
        }
    });

    lightboxCloseBtn.addEventListener('click', (e) => {
        closeLightbox(lightbox, videoGallery);
    });

    document.addEventListener('touchstart', e => {
        touchstartY = e.changedTouches[0].screenY;
    });

    document.addEventListener('touchend', e => {
        touchendY = e.changedTouches[0].screenY;
        if (document.querySelector('.video-lightbox--open')) {
            checkSwipeDirection(videoGallery);
        }
    });
}
    
function checkSwipeDirection(videoGallery) {
    removeIframe();

    if (touchendY < touchstartY) {        
        if (currentVideo + 1 >= videoCount) {
            closeLightbox(lightbox, videoGallery);
            return;
        }
        currentVideo++;
        setActiveLightboxVideo();
    }

    if (touchendY > touchstartY) {
        if (currentVideo - 1 < 0) {
            closeLightbox(lightbox, videoGallery);
            return;
        }
        currentVideo--;
        setActiveLightboxVideo();
    }
}

function setActiveLightboxVideo() {
    const openLightbox = document.querySelector('.video-lightbox--open');

    if (!openLightbox) {
        return;
    }
    const lightboxVideos = openLightbox.querySelectorAll('.video-lightbox__video');

    if (videoCount === 0) {
        videoCount = lightboxVideos.length;
    }
    
    lightboxVideos.forEach(video => {
        video.style.display = 'none';
        video.classList.add('video-lightbox__video--hidden');
        video.classList.remove('video-lightbox__video--active');
        video.ariaHidden = true;
    });

    lightboxVideos[currentVideo].style.display = 'block';
    lightboxVideos[currentVideo].classList.add('video-lightbox__video--active');
    lightboxVideos[currentVideo].classList.remove('video-lightbox__video--hidden');
    lightboxVideos[currentVideo].ariaHidden = true;
}

function openLightbox(lightbox) {
    lightbox.style.display = 'block';
    lightbox.classList.add('video-lightbox--open');
    lightbox.ariaHidden = false;

    setActiveLightboxVideo();
}

function closeLightbox(lightbox, videoGallery) {

    if (!lightbox) {
        lightbox = document.querySelector('.video-lightbox--open');
    }

    removeIframe();

    lightbox.style.display = 'none';
    lightbox.classList.remove('video-lightbox--open');
    lightbox.ariaHidden = true;
    
    currentVideo = 0;
    videoCount = 0;
    lightbox = null;

    if (videoGallery) {
        videoGallery.scrollIntoView({ behavior: 'instant' });
    }
}

function removeIframe() {
    const iframe = document.querySelector('.video__container iframe');
    if (iframe) {
        iframe.parentElement.remove();
        showPreviewImage();
    }
}

function showPreviewImage() {
    document.querySelector('.img--hidden').classList.remove('img--hidden');
    document.querySelector('.video__play-button--hidden').classList.remove('video__play-button--hidden');
}
